import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href", "onClick"]

import { onMounted, ref, watch } from "vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue"
import type { RouteLocationRaw } from "vue-router"
import { chatsStore } from "@/store/chats"
import { rootStore } from "@/store/index"
import { VersionApi } from "@/ api/VersionApi"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderLogo',
  setup(__props) {

const root = rootStore()

const serverVersion = ref('')

const homeRoute: RouteLocationRaw = {
	path: '/main',
	query: {
		page: 'chat',
		mode: 'list'
	}
}

const onLogoClick = (navigate: (e: MouseEvent) => void, e: MouseEvent) => {
	if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
		return
	}

	chatsStore().setMode('list')
	chatsStore().setOpenedChat(null)
	navigate(e)
}

const fetchServerVersion = async () => {
	const versions = await VersionApi.getVersions()
	const version = versions?.ServerVersion
	if (!version) {
		return
	}

	serverVersion.value = [version.Global, version.Component, version.Update, version.Fix].join('.')
}

onMounted(() => {
	if (root.globalJWT) {
		fetchServerVersion()
		return
	}
	const unwatch = watch(() => root.globalJWT, (token) => {
		if (token) {
			fetchServerVersion()
			unwatch()
		}
	})
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: homeRoute,
    custom: ""
  }, {
    default: _withCtx(({ href, navigate }) => [
      _createElementVNode("a", {
        href: href,
        class: "header-logo",
        onClick: ($event: any) => (onLogoClick(navigate, $event))
      }, [
        _createVNode(AppTooltip, {
          class: "header-logo__tooltip",
          text: _ctx.$t('server_version', { version: serverVersion.value }),
          disabled: !serverVersion.value
        }, {
          activator: _withCtx(() => [
            _createVNode(AppIcon, {
              name: "logo",
              width: "123px",
              height: "24px"
            })
          ]),
          _: 1
        }, 8, ["text", "disabled"])
      ], 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})